import { EChartsOption } from 'echarts';
import { BarChartConfig } from '../models/chart-types';
import {
  getTitleConfig,
  getAxisLabelConfig,
  getSplitLineConfig,
  getGridConfig,
  getLegendConfig,
  CHART_DEFAULTS,
} from '../constants/chart-theme.constants';

/**
 * Build ECharts options for bar chart
 */
export function buildBarChartOptions(config: BarChartConfig): EChartsOption {
  const options: EChartsOption = {
    title: getTitleConfig(config.title, config.subtitle),

    tooltip: {
      trigger: config.tooltip?.trigger || 'axis',
      axisPointer: {
        type: 'shadow',
      },
      ...config.tooltip,
    },

    legend: getLegendConfig(config.legend),

    grid: config.grid || getGridConfig(!!config.title),

    xAxis: {
      type: config.xAxis.type || 'category',
      data: config.xAxis.data,
      name: config.xAxis.name,
      axisLabel: getAxisLabelConfig(config.xAxis.axisLabel),
      axisLine: config.xAxis.axisLine,
      axisTick: config.xAxis.axisTick,
      splitLine: getSplitLineConfig(config.xAxis.splitLine),
    },

    yAxis: {
      type: config.yAxis.type || 'value',
      name: config.yAxis.name,
      axisLabel: getAxisLabelConfig(config.yAxis.axisLabel),
      axisLine: config.yAxis.axisLine,
      axisTick: config.yAxis.axisTick,
      splitLine: getSplitLineConfig(config.yAxis.splitLine),
    },

    series: config.series.map((series) => ({
      name: series.name,
      type: 'bar',
      data: series.data,
      color: series.color,
      stack: series.stack,
      barWidth: series.barWidth,
      barGap: series.barGap,
      itemStyle: series.itemStyle,
      emphasis: {
        focus: CHART_DEFAULTS.emphasis.focus,
      },
    })),
  };

  // Merge with custom options if provided
  return config.customOptions 
    ? { ...options, ...config.customOptions }
    : options;
}

